import useContract from './useContract';
import WrappedNoundles from '../contracts/WrappedNoundles.json';

const useWrappedNoundles = () =>
  useContract(
    process.env.NEXT_PUBLIC_WRAPPED_NOUNDLES_CONTRACT_ADDRESS,
    WrappedNoundles.abi
  );

export default useWrappedNoundles;
